import { resolveInputHint } from './kpi-metric-meta'

describe('resolveInputHint (순수)', () => {
  it('meta 없음 → number 폴백 (이름추측 없음)', () => {
    expect(resolveInputHint(null)).toEqual({ widget: 'number', readonly: false })
    expect(resolveInputHint({})).toEqual({ widget: 'number', readonly: false })
  })

  it('meta 없고 collectType AUTO → number + readonly', () => {
    expect(resolveInputHint({ collectType: 'AUTO' })).toEqual({ widget: 'number', readonly: true })
  })

  it('rating: max/step 기본값(5/1) 채움', () => {
    expect(resolveInputHint({ meta: { input: { widget: 'rating' } } })).toEqual({
      widget: 'rating',
      max: 5,
      step: 1,
      readonly: false
    })
  })

  it('rating: 명시 step(0.5)·max 는 존중', () => {
    const r = resolveInputHint({ meta: { input: { widget: 'rating', max: 10, step: 0.5 } } })
    expect(r.max).toBe(10)
    expect(r.step).toBe(0.5)
  })

  it('number: min/max passthrough + AUTO 면 readonly', () => {
    expect(resolveInputHint({ collectType: 'AUTO', meta: { input: { widget: 'number', min: 0, max: 100 } } })).toEqual({
      widget: 'number',
      min: 0,
      max: 100,
      readonly: true
    })
  })

  it('readonly 명시값(false) 은 AUTO 라도 존중 (false 가 우선)', () => {
    const r = resolveInputHint({ collectType: 'AUTO', meta: { input: { widget: 'number', readonly: false } } })
    expect(r.readonly).toBe(false)
  })

  it('select: options passthrough', () => {
    const r = resolveInputHint({ meta: { input: { widget: 'select', options: [{ value: 'A', label: 'A' }] } } })
    expect(r.widget).toBe('select')
    expect(r.options).toEqual([{ value: 'A', label: 'A' }])
  })
})
